// extracted by mini-css-extract-plugin
export default {"title_version":"ProjectMenu_title_version__XNrbG"};